import { loadProfile, saveProfile, type Profile } from './state';

/**
 * Whether the reward asks how they get back tomorrow (components/KeepAsk.tsx).
 * Once, at the first print a person reaches: Day 1's, or Day 2's when they left
 * Day 1's in the darkroom. Never for a feed already kept (the email or Google
 * is linked), nor for somebody who said no to the feed's save. Pure, for the test.
 */
export function keepAskDue(p: Pick<Profile, 'keepAsked' | 'saveDismissed' | 'madeDays'>, saved: boolean): boolean {
  return !saved && !p.keepAsked && !p.saveDismissed && p.madeDays >= 1 && p.madeDays <= 2;
}

export function markKeepAsked(): void {
  const p = loadProfile();
  if (!p.keepAsked) saveProfile({ ...p, keepAsked: true });
}
